export const API_BASE_URL = "https://api.dev.brokkerspot.com";

export const API_ENDPOINTS = {
  login: "/api/v1/admin/auth/login",
  logout: "/api/v1/admin/auth/logout",
  registerDevice: "/api/v1/admin/auth/register-device",
  forgotPassword: "/api/v1/admin/auth/forgot-password",
  verifyOtp: "/api/v1/admin/auth/forgot-password/verify-otp",
  resetPassword: "/api/v1/admin/auth/reset-password",
  usersFetch: "/api/v1/admin/users/fetch",
  brokerRequestUpdate: "/api/v1/admin/users/update/brokker-request",
  announcementsFetch: "/api/v1/admin/announcements/fetch",
  announcementsDelete: "/api/v1/admin/announcements/delete",
  announcementsUpdateStatus: "/api/v1/admin/announcements/update-status",
};

/** Base paths for master-data CRUD (add, fetch, fetch/:id, edit, delete/:id). */
export const MASTER_DATA_BASE = {
  bedrooms: "/api/v1/admin/bedrooms",
  bathrooms: "/api/v1/admin/bathrooms",
  localities: "/api/v1/admin/localities",
  languages: "/api/v1/admin/languages",
  amenities: "/api/v1/admin/amenities",
  propertyTypes: "/api/v1/admin/property-types",
  countries: "/api/v1/admin/countries",
  cities: "/api/v1/admin/cities",
};

export const USER_ENDPOINTS = {
  fetchPropertyTypes: "/api/v1/user/common/fetch-property-types",
  wishlistAdd: "/api/v1/user/announcements/wishlist/add",
  wishlistFetch: "/api/v1/user/announcements/wishlist/fetch",
  wishlistRemove: "/api/v1/user/announcements/wishlist/remove",
};

export const GUEST_ENDPOINTS = {
  announcementsFetchAll: "/api/v1/guest/announcements/fetch-all",
  announcementsFetch: "/api/v1/guest/announcements/fetch",
};
